import React from "react"
import { IconSeeker } from "@ui-seeker/core"
import { AppBulkEditAction, AppDialogCancel } from "@components"

import { alertsDrawerData, alertsDrawerErrors } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"


export default function AlertsDrawerBaseFooter({ onSubmitAlert, isLoading }) {

	return <>
		<AppDialogCancel onClick={() => alertsDrawerData.value = {}}/>
		<AppBulkEditAction
			loading={isLoading.value}
			startIcon={<IconSeeker icon="cowbell"/>}
			disabled={!Object.values(alertsDrawerErrors.value).every(a => a)}
			onClick={() => onSubmitAlert(alertsDrawerData.value)}
		>
			Submit
		</AppBulkEditAction>
	</>
}
